
































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import "../BudgetView.scss";
import { Ax } from "@/utils";
import JournalTable from "@/modules/budget/components/Journal.vue";
import store from "@/services/store";

@Component({
    components: { JournalTable }
})
export default class PdfLoader304 extends Vue {
    @Prop({ type: Object, required: true }) propData!: null;
    @Prop({ type: [], required: true })  fileBody!: null;
    @Prop({ type: String })  fileName!: string;
    @Prop({ type: File })  file!: File;

    light: string = "light";
    fields = [
        {
            key: "region",
            label: "регион",

        },
        {
            key: "year",
            label: "год",
        },
        {
            key: "date",
            label: "дата",
        },
        {
            key: "abp",
            label: "абп",
        },
        {
            key: "gu",
            label: "код гу",
        },
        {
            key: "prg",
            label: "программа",
        },
        {
            key: "ppr",
            label: "подпрограмма",
        },
        {
            key: "spf",
            label: "специфика",
        },

        {
            key: "month",
            label: "месяц",
        },
        {
            key: "amount",
            label: "сумма",
        },
        // {
        //     key: "plan_type",
        //     label: "1-обязательства; 2-платежи",
        // },
        // {
        //     key: "update_date",
        //     label: "последнее изменение",
        // },
    ];

    get userLogin(): string {
        return this.$store.state.user.sub;
    }

    async CheckHash(): Promise<void> {
        console.debug(this.file, this.fileName);
        if (!this.file || !this.fileName) return;

        const formData = new FormData();
        formData.append("file", this.file, this.fileName);

        try {
            const response = await fetch("/api-py/check-hash", {
                method: "POST",
                body: formData
            });

            const result = await response.json();
            console.log(result);

            if (result === true) {
                this.handleOk();
            } else {
                this.on304Load(formData);
            }
        } catch (error) {
            console.error("Error checking hash:", error);
        }
    }

    handleOk(): void {
        if (!this.file || !this.file.name) return;

        const formData = new FormData();
        formData.append("file", this.file, this.fileName);

        this.$bvModal
            .msgBoxConfirm("Сохранение приведет к изменению ранее принятых данных", {
                title: "Подтвердите",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "Сохранить",
                cancelTitle: "Отменить",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true
            })
            .then((value: boolean) => {
                console.log("Save", value);
                if (value) {
                    this.on304Load(formData);
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    on304Load(formData: FormData): void {
        const user = this.userLogin;
        this.$emit("save-load304", true);

        Ax({
            url: `/api-py/save-b304/${user}`,
            method: "POST",
            data: formData
        }, data => {
            console.debug("Data", data)
        });

        this.makeToast("success", "Загрузка файла начата! Результат в журнале Загрузки", "Результат");
        this.$emit("save-load304", false);
    }

    onClear(): void {
        this.$emit("form-clear304", {});
    }

    makeToast(variant: string, tostbody: string, title: string): void {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            autoHideDelay: 2000,
            solid: true
        });
    }

    keyEvent(event: KeyboardEvent): void {
        // Обработчик событий клавиатуры (пока пуст)
    }
}

